<template>
  <div class="LoginHeader d-flex justify-content-end align-items-center">
    <div>
      <p class="LoginHeaderTitle text-right">جالیزان</p>
      <p class="LoginHeaderDescription mb-0">دستیار هوشمند کشاورز</p>
    </div>

    <div class="LoginHeaderImage"></div>
  </div>
</template>

<script>
export default {
  name: "LoginHeader"
}
</script>

<style lang="scss">
@import "src/styles/modules/Layout/LoginHeader";
</style>